import type { CoachProfile } from '@efdigital/ll-addon-data';
import type CoachService from '@efdigital/ll-xceed-v2/services/coach';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export interface CoachingCoachModel {
  coach: CoachProfile;
}

export default class CoachingCoachRoute extends Route<CoachingCoachModel> {
  @service declare coach: CoachService;

  async model(): Promise<CoachingCoachModel> {
    const coach = await this.coach.getPublishedProfile();
    return {
      coach,
    };
  }
}
